export default {
  navbar: {
    home: '首页',
    shipping: '购物',
    faq: '利海商圈（杭州）互联网有限公司',
    returns: 'Returns Policy',
    trackOrder: 'Track Order',
    search: '搜索',
    user: '用户',
    cart: '购物车',
    favorite: '收藏',
    usd: 'USD',
    eng: 'ENG',
    zhong: '中文'
  },
  menu: {
    category1: '香薰香烛',
    category2: '中国非遗',
    category3: '运河文化',
    homeFragrance: '家用香薰',
    carFragrance: '车载香薰',
    incense: '非遗线香',
    commercialFragrance: '商用香薰',
    copper: '朱炳仁铜',
    ceramics: '景德镇陶瓷',
    yixing: '非遗紫砂',
    lecture: '运河饰品',
    life: '运河生活',
    creative: '运河文创',
    experience: '运河体验',
    gift: '运河礼品',
    latestNews: '最新消息',
    about: '公司简介',
    lihaibc: '利海商圈',
    contact: '联系我们',
    join: '合作加盟'
  },
  footer: {
    brand: '利海商圈',
    description: '利海商圈（杭州）互联网有限公司，是一家集跨境电商销售、企业管理咨询、企业 AI 部署实践咨询于一体的综合性互联网企业。',
    contactUs: '联系我们',
    phone: '18367329869',
    email: '邮箱',
    emailAddr: 'huhanlin@@lihaibc.com',
    address: '地址',
    addressText: '浙江省杭州市滨江区正泰大厦5楼利海商圈（杭州）互联网有限公司',
    quickLinks: '快速链接',
    home: '首页',
    homeFragrance: '家用香薰',
    carFragrance: '车载香薰',
    incense: '非遗线香',
    aboutUs: '关于我们',
    contact: '联系我们',
    resources: '资源与服务',
    faq: '常见问题',
    shipping: '运输政策',
    returns: '退换货指南',
    privacy: '隐私保护',
    adminPortal: '合作加盟',
    adminLogin: '经销商登录',
    copyright: '矢车菊香薰官网. 版权所有',
    AfterSalesService: '售后服务'
  },
  common: {
    home: '首页',
    product: '产品',
    productDetail: '产品详情',
    price: '价格',
    addToCart: '加入购物车',
    buyNow: '立即购买',
    quantity: '数量',
    stock: '库存',
    category: '分类',
    all: '全部',
    sort: '排序',
    sortBy: '排序方式',
    sales: '销量排序',
    priceAsc: '价格从低到高',
    priceDesc: '价格从高到低',
    found: '找到',
    items: '件商品',
    noProducts: '暂无产品',
    loading: '加载中...',
    submit: '提交',
    cancel: '取消',
    confirm: '确认',
    success: '成功',
    error: '错误',
    required: '必填',
    optional: '选填'
  },
  login: {
    title: '用户登录',
    login: '登录',
    username: '账号',
    usernamePlaceholder: '请输入用户名或邮箱',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    rememberMe: '记住我',
    forgotPassword: '忘记密码？',
    noAccount: '还没有账号？',
    registerNow: '立即注册',
    loginSuccess: '登录成功',
    loginFailed: '登录失败'
  },
  register: {
    title: '用户注册',
    register: '注册',
    username: '用户名',
    email: '邮箱',
    password: '密码',
    confirmPassword: '确认密码',
    phone: '手机号',
    hasAccount: '已有账号？',
    loginNow: '立即登录',
    registerSuccess: '注册成功'
  },
  contact: {
    title: '联系我们',
    companyName: '公司名称',
    contactPerson: '联系人',
    phone: '电话',
    email: '邮箱',
    message: '留言内容',
    submit: '提交留言',
    success: '留言提交成功',
    required: '请填写'
  },
  productDetail: {
    price: '价格',
    stock: '库存',
    quantity: '数量',
    addToCart: '加入购物车',
    buyNow: '立即购买',
    productDetail: '产品详情',
    intro: '产品简介',
    specParams: '规格参数',
    spec: '规格'
  },
  wishlist: {
    productName: '产品名称',
    specification: '规格',
    salesPrice: '销售价',
    activePrice: '活动价',
    stock: '库存',
    quantity: '数量',
    action: '操作',
    addToCart: '加入购物车',
    noItems: '暂无收藏商品',
    loading: '加载中...',
    addedToCart: '已加入购物车',
    loginFirst: '请先登录',
    addFailed: '加入购物车失败'
  },
  shoppingCart: {
    productName: '产品名称',
    specification: '规格',
    price: '单价',
    quantity: '数量',
    action: '操作',
    selectAll: '全选',
    totalPrice: '合计',
    totalQuantity: '共',
    items: '件商品',
    checkout: '去结算',
    noItems: '购物车暂无商品',
    loading: '加载中...',
    delete: '删除',
    loginFirst: '请先登录',
    addFailed: '加入购物车失败',
    paypal: 'PayPal',
    wechat: '微信支付',
    alipay: '支付宝',
    confirmPay: '确认支付',
    cancel: '取消'
  },
  user: {
    title: '个人中心',
    profile: '个人资料',
    orders: '我的订单',
    address: '收货地址',
    favorite: '我的收藏',
    wishlist: '我的收藏',
    settings: '设置',
    logout: '退出登录'
  },
  news: {
    latestNews: '最新消息',
    readMore: '阅读更多',
    publishDate: '发布时间',
    clicks: '浏览',
    likes: '点赞'
  }
}